import React from 'react';

/**
 * Skeleton placeholder that mirrors the actual ProductCard layout
 * (image → category eyebrow → name → price → CTA) so the grid keeps
 * its rhythm while data loads. Uses the brand cream/line palette
 * with a slow shimmer instead of the harsh gray `animate-pulse` block.
 */
const ProductCardSkeleton = ({ variant = 'default' }) => {
  const isFeatured = variant === 'featured';

  return (
    <div
      className="group relative"
      style={{ background: 'transparent', border: 'none' }}
      aria-hidden="true"
      data-testid="product-card-skeleton"
    >
      {/* Image placeholder — same 3/4 aspect ratio as the real card */}
      <div
        className="relative block overflow-hidden shimmer-block"
        style={{
          aspectRatio: '3/4',
          background: 'var(--line-soft, #efe6d6)',
        }}
      />

      {/* Text placeholders */}
      <div className="pt-4 pb-2">
        {/* Category eyebrow */}
        <div
          className="shimmer-block"
          style={{
            height: '10px',
            width: '35%',
            marginBottom: '10px',
            background: 'var(--line, #e2d5c1)',
          }}
        />

        {/* Product name (2 lines like line-clamp-2) */}
        <div
          className="shimmer-block"
          style={{
            height: isFeatured ? '22px' : '18px',
            width: '85%',
            marginBottom: '8px',
            background: 'var(--line, #e2d5c1)',
          }}
        />
        <div
          className="shimmer-block"
          style={{
            height: isFeatured ? '22px' : '18px',
            width: '55%',
            marginBottom: '14px',
            background: 'var(--line, #e2d5c1)',
          }}
        />

        {/* Price */}
        <div
          className="shimmer-block"
          style={{
            height: '14px',
            width: '30%',
            marginBottom: '18px',
            background: 'var(--line, #e2d5c1)',
          }}
        />

        {/* CTA button placeholder */}
        <div
          className="shimmer-block"
          style={{
            height: '38px',
            width: '100%',
            border: '1px solid var(--line, #e2d5c1)',
            background: 'transparent',
          }}
        />
      </div>
    </div>
  );
};

export default ProductCardSkeleton;
